import React from 'react';
import { instanceOf, func, bool } from 'prop-types';

import { DragSource as dragSource } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';

import TCTreeList from './TCTreeList';

const source = {
  beginDrag(props) {
    const { item, funcs } = props;
    funcs.onDrag(item);
    return {
      item,
    };
  },
  endDrag({ funcs }, monitor) {
    if (!monitor.didDrop()) {
      return;
    }
    const { onDrop } = funcs;
    onDrop();
  },
};

const collect = (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  isDragging: monitor.isDragging(),
  connectDragPreview: connect.dragPreview(),
});

const TCTreeItem = ({
  item,
  funcs,
  isDragging,
  connectDragSource,
  canDrag,
  connectDragPreview,
}) => {
  connectDragPreview(getEmptyImage(), {
    captureDraggingState: true,
  });

  const { toggleOpen, childClick } = funcs;
  const { isSelected, isActive, title } = item;
  const treeItemActiveClass = item.isOpen
    ? 'ie--tree--item ie--tree--item--open'
    : 'ie--tree--item';
  let isSelectedClass = isSelected ? 'ie--tree--action--selected' : ' ';
  if (isDragging) {
    isSelectedClass += ' ie--tree--action--draging';
  }

  let actionButton = (
    <button
      type="button"
      className={'ie--tree--action ie--tree--action--parent'}
      onClick={() => toggleOpen(item)}
      title={title}
    >
      {title}
    </button>
  );

  if (isActive) {
    actionButton = (
      <div title={title} className="ie--tree--action ie--tree--action--active">
        {title}
      </div>
    );
  }

  if (canDrag && !isActive) {
    return connectDragSource(
      <div className="ie--tree--item">
        <div
          className={`ie--tree--action ie--tree--action--child ${isSelectedClass}`}
          onClick={e => childClick(e, item)}
          title={title}
          role="button"
          tabIndex="0"
        >
          {title}
        </div>
      </div>
    );
  }

  return (
    <div className={treeItemActiveClass}>
      {actionButton}
      {item.options && item.options.length > 0 && item.isOpen && (
        <TCTreeList canDrag tree={item.options} funcs={funcs} />
      )}
    </div>
  );
};

TCTreeItem.propTypes = {
  item: instanceOf(Object).isRequired,
  funcs: instanceOf(Object).isRequired,
  connectDragSource: func,
  connectDragPreview: func,
  isDragging: bool,
  canDrag: bool,
};

export default dragSource('TC_OPTIONS', source, collect)(TCTreeItem);
